import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Titulo, Hr, Button, Table, Row, Input, Background } from "./style";
import excel from "../../../assets/Images/excel.png";
import { IoPencilOutline, IoTrashOutline } from "react-icons/io5";
import pdf from "../../../assets/Images/pdf.png";
import Auth from "../../../services/auth";
import api from "../../../services/api";
import { Swal, Toast } from "../../../services/SwalTemplates";
import Pagination from "../../../components/Pagination";
import { Link } from "react-router-dom";
import config from "../../../assets/json/texts.json";
import { isAuthenticatedDiretor } from "../../../auth";

const { STATIC_URL_DEV, STATIC_URL_PROD } = config;

export default function ProjetosLancamentos() {
  const [auth] = useState(Auth.auth());
  const navigate = useNavigate();
  const [id] = useState(Auth.id());
  const [projetos, setProjetos] = useState([]);
  const [projetosBK, setProjetosBK] = useState([]);
  const [searchProjetos, setSearchProjetos] = useState("");
  const [searchColaboradores, setSearchColaboradores] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const diretor = isAuthenticatedDiretor();

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    let filtro = projetosBK.filter((projeto) => projeto.projeto.toUpperCase().includes(searchProjetos.toUpperCase()));
    if (searchProjetos !== "") setProjetos(filtro);
    else setProjetos(projetosBK);
  }, [searchProjetos]);

  useEffect(() => {
    let filtro = projetosBK.filter((projeto) => projeto.colaborador.toUpperCase().includes(searchColaboradores.toUpperCase()));
    if (searchColaboradores !== "") setProjetos(filtro);
    else setProjetos(projetosBK);
  }, [searchColaboradores]);
  /* eslint-enable react-hooks/exhaustive-deps */

  useEffect(() => {
    api
      .get(`/coord/projetoslancamentos?idUsuario=${id}&nome=${searchProjetos}`)
      .then((response) => {
        setProjetos(response.data.projetos);
        setProjetosBK(response.data.projetos);
        // console.log("Projetos carregados:", response.data.projetos);
      })
      .catch(() => {
        Swal.fire({
          title: "Atenção!",
          text: "Não foi possível consultar os dados!",
          icon: "error",
        });
      });
  }, [id]);

  useEffect(() => {
    setTotalPages(Math.ceil(projetos.length / 15));
  }, [projetos]);

  function handleDelete(id) {
    Swal.fire({
      title: "Você tem certeza?",
      text: "Você não poderá reverter essa ação!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Deletar",
      cancelButtonColor: "gray",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await api.delete(`/coord/projetoslancamentos/${id}?auth=${auth}`);
        if (response.data.error) {
          return Swal.fire("Exclusão não permitida!", response.data.error, "warning");
        }
        Toast.fire({
          icon: "success",
          title: "Deletado com sucesso!",
        });
        setProjetos(projetos.filter((projeto) => projeto.id !== id));
      }
    });
  }

  return (
    <Background>
      <Container>
        <Titulo>Lançamentos de Atividades</Titulo>
        <Hr />
        <Row>
          <Link to="/projetoslancamentos/cadastro" hidden={diretor}>
            <Button>Novo</Button>
          </Link>
          <Input>
            <input
              value={searchProjetos}
              onChange={(e) => {
                setSearchProjetos(e.target.value.toUpperCase());
              }}
              type="text"
              placeholder="Nome da Atividade..."
            />
          </Input>
          <Input>
            <input
              value={searchColaboradores}
              onChange={(e) => {
                setSearchColaboradores(e.target.value.toUpperCase());
              }}
              type="text"
              placeholder="Nome do Colaborador..."
            />
          </Input>
        </Row>
        <Table>
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Atividade</th>
                <th>Colaborador</th>
                <th>Matrícula</th>
                <th>Data início</th>
                <th>Data fim</th>
                <th>Unidade</th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {projetos.slice((page - 1) * 15, page * 15).map((p, i) => (
                <tr key={i}>
                  <td data-title="Id">{p.id}</td>
                  <td title={p.projeto} data-title="Atividade" className="td-left">
                    {p.projeto.slice(0, 25)}
                    {p.projeto.length > 25 ? "..." : ""}
                  </td>
                  <td data-title="Colaborador" className="td-left" title={p.colaborador}>
                    {p.colaborador.slice(0, 30)}
                    {p.colaborador.length > 30 ? "..." : ""}
                  </td>
                  <td data-title="Matrícula">{p.matricula_colaborador}</td>
                  <td data-title="Data início">{p.data_inicio}</td>
                  <td data-title="Data fim">{p.data_fim}</td>
                  <td data-title="Unidade" className="td-left" title={p.unidade}>
                    {p.unidade.slice(0, 20)}
                    {p.unidade.length > 20 ? "..." : ""}
                  </td>
                  <td data-title="Editar" hidden={diretor}>
                    <IoPencilOutline
                      title="Editar"
                      style={{ fontSize: "25px", cursor: "pointer" }}
                      onClick={() => {
                        navigate("/projetoslancamentos/edicao", {
                          state: {
                            id: p.id,
                            id_projeto: p.id_projeto,
                            projeto: p.projeto,
                            matricula_colaborador: p.matricula_colaborador,
                            colaborador: p.colaborador,
                            data_inicio: p.data_inicio,
                            data_fim: p.data_fim,
                            anexo: p.anexo,
                          },
                        });
                      }}
                    />
                  </td>
                  <td data-title="Excluir" hidden={diretor}>
                    <IoTrashOutline
                      title="Excluir"
                      style={{ fontSize: "25px", cursor: "pointer" }}
                      onClick={() => {
                        handleDelete(p.id);
                      }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Table>
        <Pagination page={page} setPage={setPage} totalPages={totalPages} />
      </Container>
    </Background>
  );
}
